/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleGroupCreate
 */
export interface VehicleGroupCreate {
    /**
     * 
     * @type {string}
     * @memberof VehicleGroupCreate
     */
    label: string;
    /**
     * Create `VehicleGroupAssignment`s for these `Vehicle`s.
     * @type {Array<string>}
     * @memberof VehicleGroupCreate
     */
    vehicleIds?: Array<string> | null;
    /**
     * Create `UserGroupVehicleGroupAssignment`s for these `UserGroup`s.
     * @type {Array<string>}
     * @memberof VehicleGroupCreate
     */
    userGroupIds?: Array<string> | null;
}

/**
 * Check if a given object implements the VehicleGroupCreate interface.
 */
export function instanceOfVehicleGroupCreate(value: object): value is VehicleGroupCreate {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function VehicleGroupCreateFromJSON(json: any): VehicleGroupCreate {
    return VehicleGroupCreateFromJSONTyped(json, false);
}

export function VehicleGroupCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleGroupCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'vehicleIds': json['vehicleIds'] == null ? undefined : json['vehicleIds'],
        'userGroupIds': json['userGroupIds'] == null ? undefined : json['userGroupIds'],
    };
}

export function VehicleGroupCreateToJSON(json: any): VehicleGroupCreate {
    return VehicleGroupCreateToJSONTyped(json, false);
}

export function VehicleGroupCreateToJSONTyped(value?: VehicleGroupCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'vehicleIds': value['vehicleIds'],
        'userGroupIds': value['userGroupIds'],
    };
}

